import { Component, OnInit } from '@angular/core';
import {InfluxService} from "./influx.service";

@Component({
    selector: 'app-influx',
    templateUrl: './influx.component.html',
    standalone: false
})
export class InfluxComponent implements OnInit {

  constructor(
    private service: InfluxService
  ) { }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    this.service.query().subscribe((resp:any) => {
      console.log("resp:", resp);
    })
  }

}
